import React from 'react';
import { isWeeklyActiveTrader } from '../utils/isWeeklyActiveTrader';

/**
 * Badge that displays on pedal listing images for weekly active users
 * Shows in top-right corner with "Active" text above icon and "Trader" text below
 */
const ActiveTraderBadge = ({ user, className = '' }) => {
  // Don't show badge if user is not active this week
  if (!isWeeklyActiveTrader(user)) {
    return null;
  }

  return (
    <div 
      className={`active-trader-badge ${className}`}
      style={{
        position: 'absolute',
        top: '16px',
        right: '16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '2px',
        background: 'rgba(255, 255, 255, 0.95)',
        padding: '6px 8px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
        zIndex: 10,
        pointerEvents: 'none' // Allow clicking through to the pedal
      }}
      title="This user is an active trader (visited this week)"
    >
      <span 
        style={{
          fontSize: '9px',
          fontWeight: '600',
          color: '#87A333',
          letterSpacing: '0.5px',
          textTransform: 'uppercase',
          lineHeight: '1',
          textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
        }}
      >
        Active
      </span>
      <img 
        src="/images/Active_Trader.png" 
        alt="Active Trader"
        style={{
          width: '24px',
          height: '24px',
          display: 'block',
          filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))'
        }}
      />
      <span 
        style={{
          fontSize: '9px',
          fontWeight: '600',
          color: '#87A333',
          letterSpacing: '0.5px',
          textTransform: 'uppercase',
          lineHeight: '1',
          textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
        }}
      >
        Trader
      </span>
    </div>
  );
};

export default ActiveTraderBadge;
